(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  const countdownSection = document.querySelector('[js-countdown]');

  if (!countdownSection) {
    return;
  }
  
  const timestamp = countdownSection.dataset.timestamp;

  if (!timestamp) {
    console.error('No timestamp provided for countdown');
    return;
  }

  const targetDate = new Date(timestamp).getTime();
  const countdownDisplay = document.querySelector('[js-countdown="countdown"]');

  function updateCountdown() {
    const now = Date.now();
    const timeDifference = targetDate - now;

    if (timeDifference <= 0) {
      countdownDisplay.style.visibility = 'hidden';
      countdownDisplay.style.width = 0;
      return;
    }

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    countdownDisplay.textContent = `${days}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  updateCountdown();
  const countdownInterval = setInterval(updateCountdown, 1000);

  clearTimerInterval();

  function clearTimerInterval() {
    if (targetDate <= Date.now()) {
      clearInterval(countdownInterval);
      countdownDisplay.style.visibility = 'hidden';
      countdownDisplay.style.width = 0;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  if (!document.querySelector && !window.addEventListener && !("classList" in d.createElement("p"))) return;

  /* Description Tabs */
  var Tabs = function () {
    this.ele = document.querySelector('[data-tabs]');
    if (!this.ele) return;

    this.actions = this.ele.querySelectorAll('[data-tab-target]');
    this.active = this.ele.querySelector('[data-tab-active]');
    if (this.actions.length) {
      document.documentElement.classList.add('has-tabs');
      this._addEventListeners();
      this.closeAllTabs();
      this.openActive();
    }
  };
  Tabs.prototype.openTab = function (ele) {
    this.active = ele;
    ele.setAttribute('data-tab-active', '');
    var targetStr = ele.getAttribute('data-tab-target');
    var target = this.ele.querySelector(targetStr);
    target.style.display = 'block';
  };
  Tabs.prototype.closeTab = function (ele) {
    ele.removeAttribute('data-tab-active');
    var targetStr = ele.getAttribute('data-tab-target');
    var target = this.ele.querySelector(targetStr);
    target.style.display = 'none';
  };
  Tabs.prototype.closeAllTabs = function () {
    var target,
      targetStr,
      _this = this;
    this._eachAction(function (tabAction) {
      _this.closeTab(tabAction);
    });
  };
  Tabs.prototype.openActive = function () {
    var active = this.active;
    if (!!location.hash) {
      active = this.ele.querySelector('[href="'+location.hash+'"]');
    }
    if (active) {
      this.openTab(active);
    }
  };
  Tabs.prototype._updateHash = function (hash) {
    if (history.pushState) {
      history.pushState(null, null, hash);
    } else {
      location.hash = hash;
    }
  };
  Tabs.prototype._addEventListeners = function () {
    var _this = this;
    this._eachAction(function (tabAction) {
      tabAction.addEventListener('click', function (e) {
        e.preventDefault();
        _this.closeAllTabs();
        _this.openTab(e.currentTarget);
        //_this._updateHash(e.currentTarget.getAttribute('href'));
        e.currentTarget.blur();
      });
    });
  };
  Tabs.prototype._eachAction = function (callback) {
    for (var i = 0; i < this.actions.length; i++) {
      callback(this.actions[i]);
    }
  };
  new Tabs();

  $(document).on('shopify:section:load', function () {
    new Tabs();
  });

  /* Description Accordian */
  var Accordian = function (ele) {
    this.ele = ele;
    this.actions = this.ele.querySelectorAll('[data-accordian-target]');
    this.sections = this.ele.querySelectorAll('[data-accordian-section]');
    this._addeventListeners();
    this.closeSections();
  };

  Accordian.prototype.openSection = function (action) {
    var targetSelector = action.getAttribute('data-accordian-target');
    var target = this.ele.querySelector(targetSelector);
    var isVisible = (target.style.display === 'block');
    this.closeSections();
    if (!isVisible) {
      target.style.display = 'block';
      action.querySelector('.icon-minus').style.display = 'inline-block';
      action.querySelector('.icon-plus').style.display = 'none';
    }
  };

  Accordian.prototype.closeSections = function () {
    for (var i = 0; i < this.sections.length; i++) {
      this.sections[i].style.display = 'none';
    };
    for (var i = 0; i < this.actions.length; i++) {
      this.actions[i].querySelector('.icon-plus').style.display = 'inline-block';
      this.actions[i].querySelector('.icon-minus').style.display = 'none';
    }
  };

  Accordian.prototype._addeventListeners = function () {
    var _this = this;
    for (var i = 0; i < this.actions.length; i++) {
      this.actions[i].addEventListener('click', function (e) {
        _this.openSection(e.currentTarget);
      });
    }
  };

  // main
  var accordians = document.querySelectorAll('[data-accordian]');
  for (var i = 0; i < accordians.length; i++) {
    new Accordian(accordians[i]);
  }

  } catch(e) { console.error(e); }
})();
})();
